export var INPUT_WITH_SECONDS_MIN_WIDTH = 235;
export var INPUT_WITH_MS_MIN_WIDTH = INPUT_WITH_SECONDS_MIN_WIDTH + 25;